
import {TableLoading} from "../../../../../loading";
import SavedFiltersEmptyTableBlock from "./EmptyTableBlock";
import {TableResultsSeeker} from "ui-seeker/core";
import React from "react"
import {actionsColumn, nameColumn} from "./@columns";
import {useList} from "./@hooks";

export default function SavedFiltersTable({controller}) {
    const {dataSavedFilters, isLoadingDataSavedFilters} = useList()

    if (isLoadingDataSavedFilters) return <TableLoading />

    if (!dataSavedFilters.length) return <SavedFiltersEmptyTableBlock />

    return <TableResultsSeeker
        data={dataSavedFilters}
        columns={[
            nameColumn(),
            actionsColumn(controller)
        ]}
        className="table-reports"
        options={{
            viewColumns: false,
            pagination: false,
        }}
    />
}